import api from "./api";

// Credenciales de PLATAFORMA (doc 0440): Meta, Instagram y Telegram. Solo superadmin, salvo
// `availability`, que cualquiera puede consultar y solo dice sí/no por canal.
export const getPlatformIntegrations = () => api.get("/platform-integrations");
export const savePlatformIntegration = (provider, values) => api.put(`/platform-integrations/${provider}`, { values });
export const revealPlatformSecret = (provider, key) => api.get(`/platform-integrations/${provider}/${key}/reveal`);
export const getChannelAvailability = () => api.get("/platform-integrations/availability");
